import React, { useState, useRef } from "react";
import { DatePicker, Flex } from "antd";
import dayjs from "dayjs";
import weekdayPlugin from "dayjs/plugin/weekday";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/en";

dayjs.extend(weekdayPlugin);
dayjs.extend(customParseFormat);

export default function TravelDateDisplay() {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleChange = (date) => {
    if (date) {
      setSelectedDate(date);
      setOpen(false);
    }
  };

  const day = selectedDate.date();
  const month = selectedDate.format("MMM");
  const year = selectedDate.format("YYYY");
  const weekday = selectedDate.format("dddd");

  return (
    <div className="relative">
      {/* Visible Travel Date Display */}
      <div
        ref={ref}
        className="cursor-pointer transition"
        onClick={() => setOpen(true)}
      >
        <div className="text-sm  mb-1">Travel Date</div>
        <Flex align="flex-end" gap={4}>
        <div className="text-4xl font-bold">{day}</div>
        <div className="text-xl font-medium">
          {month}’ {year}
        </div>
        </Flex>
        <div className="text-base font-medium mt-1">{weekday}</div>
      </div>

      {/* Off-screen but rendered DatePicker (so popup works properly) */}
      <div className="absolute top-0 left-0 opacity-0 pointer-events-none">
        <DatePicker
          open={open}
          onOpenChange={setOpen}
          value={selectedDate}
          onChange={handleChange}
          getPopupContainer={() => ref.current} // Attach to the trigger
        />
      </div>
    </div>
  );
}
